export default "__VITE_ASSET__zfl1i4hQ__"